const registration = {
  namespaced: true,

  state: {
    statusPerusahaan: 'N',
    statusIjin: 'N',
    statusAkta: 'N',
    statusPemilik: 'N',
    statusPengurus: 'N',
    statusPengalaman: 'N',
    statusPajak: 'N'
  },

  getters: {
    // state langsung
    statusPerusahaan: state => state.statusPerusahaan,
    statusIjin: state => state.statusIjin,
    statusAkta: state => state.statusAkta,
    statusPemilik: state => state.statusPemilik,
    statusPengurus: state => state.statusPengurus,
    statusPengalaman: state => state.statusPengalaman,
    statusPajak: state => state.statusPajak,
  },

  mutations: {
    setStatusPerusahaan: function(state, status) {
      state.statusPerusahaan = status
    },
    setStatusIjin: function(state, status) {
      state.statusIjin = status
    },
    setStatusAkta: function(state, status) {
      state.statusAkta = status
    },
    setStatusPemilik: function(state, status) {
      state.statusPemilik = status
    },
    setStatusPengurus: function(state, status) {
      state.statusPengurus = status
    },
    setStatusPengalaman: function(state, status) {
      state.statusPengalaman = status
    },
    setStatusPajak: function(state, status) {
      state.statusPajak = status
    },
  },

  actions: {
    assignStatusDoc: function(context, val) {
      context.commit('setStatusPerusahaan', val.statusPerusahaan)
      context.commit('setStatusIjin', val.statusIjin)
      context.commit('setStatusAkta', val.statusAkta)
      context.commit('setStatusPemilik', val.statusPemilik)
      context.commit('setStatusPengurus', val.statusPengurus)
      context.commit('setStatusPengalaman', val.statusPengalaman)
      context.commit('setStatusPajak', val.statusPajak)
    }
  }
}

export default registration